import { h, Host } from "@stencil/core";
import { BEM } from "../../../utils/bem";
export class StageBackLink {
    constructor() {
        this.href = undefined;
        this.shadow = false;
        this.inverted = false;
    }
    render() {
        const block = BEM.block('stage-back-link');
        return (h(Host, { key: '694c383572bafaa4202bba16706281834fb48b2c', class: Object.assign(Object.assign({}, block.class()), block.modifier('shadow').class(this.shadow)) }, h("a", { key: 'a8b7bc405efac0263298ed194ee0a90153b16a32', class: {
                'link': true,
                'is-inverted': this.inverted,
            }, href: this.href }, h("bal-icon", { key: '786b949805a3ae3c99bfc7c713bcd4d8872f94a5', class: "mr-x-small", name: "caret-left", size: "x-small", inverted: this.inverted, shadow: this.shadow }), h("slot", { key: 'e7c639e47c25370416eade21dd2e67f82588fe6b' }))));
    }
    static get is() { return "bal-stage-back-link"; }
    static get properties() {
        return {
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the URL of the page the link goes to"
                },
                "getter": false,
                "setter": false,
                "attribute": "href",
                "reflect": false
            },
            "shadow": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If `true` adds a text shadow to improve readability on image background"
                },
                "getter": false,
                "setter": false,
                "attribute": "shadow",
                "reflect": false,
                "defaultValue": "false"
            },
            "inverted": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If `true` the color gets inverted for dark backgrounds"
                },
                "getter": false,
                "setter": false,
                "attribute": "inverted",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
